import { List } from "antd";


export function getAcquirerAccessList() {
  let userMXPermissions = JSON.parse(sessionStorage.getItem("state")).auth.user
    .parsedPermissions.queue.viewMxQueues;
  let userGPPermissions = JSON.parse(sessionStorage.getItem("state")).auth.user
    .parsedPermissions.queue.viewGPNQueues;
  let userHPYPermissions = JSON.parse(sessionStorage.getItem("state")).auth.user
    .parsedPermissions.queue.viewHPYQueues;
  let userEVOPermissions = JSON.parse(sessionStorage.getItem("state")).auth.user
    .parsedPermissions.queue.viewEvoQueues;
  let userGPEPermissions = JSON.parse(sessionStorage.getItem("state")).auth.user
    .parsedPermissions.queue.viewGPEQueues;

  var acquirerAccess = new Array();

  if (userMXPermissions) {
    acquirerAccess.push("MXP");
    acquirerAccess.push("MXI");
  }
   if (userGPPermissions) {
    acquirerAccess.push('GPN');
    acquirerAccess.push('GPNPD');
  }
  if(userHPYPermissions){
    acquirerAccess.push('HPY');
    acquirerAccess.push('HPYPD');
  }
  if (userEVOPermissions) {
    acquirerAccess.push("EMD");
    acquirerAccess.push("EMI");
  }  
  if (userGPEPermissions) {
    acquirerAccess.push('GPE');
  }
  return acquirerAccess;
}

export function getHeaderDataButtons() {
  return [
    {
      buttonName: 'Card Brand Data',
      buttonID: 2,
    },
    {
      buttonName: 'Case Data',
      buttonID: 1,
    },
    {
      buttonName: 'Auth Data',
      buttonID: 3,
    },
    {
      buttonName: 'Tran Data',
      buttonID: 4,
    },
  ];
}